import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import Avatar from "react-avatar";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../components/Shared/Button/Button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const FriendsPage = () => {
  const { token } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [friends, setFriends] = useState([]);

  const getFriends = async () => {
    setIsLoading(true);
    // make a request to get the friends of the user
    const response = await axios
      .get(`${BACKEND_URL}/users/friends/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        setIsLoading(false);
      });
    // if response is received from the server set the friends
    if (response) {
      setFriends(response.data.friends);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getFriends();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="px-6 py-10 w-full">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-[600]">Friends Page</h1>
      </div>
      {!isLoading && (
        <div className="my-3">
          {friends.map((friend) => (
            <div
              className="flex justify-between items-center gap-2 cursor-pointer my-6 border-b-2 border-b-gray-200 pb-6"
              onClick={() => navigate(`/profile/${friend._id}`)}
              key={friend._id}
            >
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => navigate(`/profile/${friend._id}`)}
              >
                <Avatar
                  name={`${friend.firstName} ${friend.lastName}`}
                  size="50"
                  round={10}
                />
                <div>
                  <h1 className="text-lg font-bold">
                    {friend?.firstName} {friend?.lastName}
                  </h1>
                  <p className="text-md">@{friend?.userName}</p>
                </div>
              </div>
              <Button type="button">View Profile</Button>
            </div>
          ))}
          {friends.length === 0 && (
            <div className="flex flex-col justify-center items-center my-3">
              <p className="text-xl font-[500]">You have no friends</p>
            </div>
          )}
        </div>
      )}
      {isLoading && (
        <div className="my-3 h-96 flex justify-center items-center">
          <Oval color="#337CAB" height={50} width={50} />
        </div>
      )}
    </div>
  );
};

export default FriendsPage;
